<template>
  <div class="d-flex align-center">
    <AppTooltip location="bottom">
      <template #activator="{ props }">
        <!-- The glyph renders its own name as text, so without an accessible name a screen
             reader would announce "folder_check". The room type is carried by the icon alone
             here, the tooltip only revealing it on hover, so it gets a localised label rather
             than being hidden. -->
        <app-material-icon
          :name="roomIcon.name"
          :color="roomIcon.color"
          :size="width"
          filled
          role="img"
          :aria-label="roomTypeLabel"
          v-bind="props"
        />
      </template>
      <span v-if="room.isDataroom">{{ $t('common.RoomTypeIcon.dataroom') }}</span>
      <span v-else>{{ $t('common.RoomTypeIcon.project') }}</span>
    </AppTooltip>
  </div>
</template>

<script>
import AppTooltip from './AppTooltip.vue'
import { getRoomIcon } from './utils/rooms'

export default {
  name: 'RoomTypeIcon',
  components: { AppTooltip },
  props: {
    room: {
      type: Object,
      required: true,
    },
    width: {
      type: Number,
      default: 24,
    },
  },
  computed: {
    roomIcon () {
      return getRoomIcon(this.room)
    },
    roomTypeLabel () {
      return this.room.isDataroom
        ? this.$t('common.RoomTypeIcon.dataroom')
        : this.$t('common.RoomTypeIcon.project')
    },
  },
}
</script>
